import { graphql } from 'gatsby';
import React, { FC, useContext } from 'react';
import { UiStateContext } from '../../../../context/UiStateContext';
import { MyKfhLoginFragment } from '../../../../types/graphqlTypes';
import { CTACard } from '../../../CtaCard';
import { Grid } from '../../../Grid';
import { Login } from '../../../my-kfh/Login';
import { RegisterBlade } from '../../../my-kfh/RegisterBlade';
import { Panel } from '../../../Panel';

export const MyKfhLogin: FC<MyKfhLoginFragment> = ({ registerHeading, registerLead, registrationBenefits }) => {
  const { setActiveBlade } = useContext(UiStateContext);
  return (
    <>
      <Grid desktopColumns="2">
        <Panel backgroundColor="white" shadow heading="Log in" headingComponent="h2">
          <Login />
        </Panel>
        <CTACard
          backgroundColour="brand"
          title={registerHeading}
          lead={registerLead}
          tickLisItems={registrationBenefits}
          customButton={{
            label: 'Register for MyKFH',
            onClick: () => setActiveBlade('register'),
            eventClickBladeId: 'register',
          }}
          shadow
          headingComponent="h2"
        />
      </Grid>
      <RegisterBlade />
    </>
  );
};

export const MyKfhLoginQuery = graphql`
  fragment MyKfhLogin on KFH_UmbracoMyKfhLoginComponentType {
    registerHeading
    registerLead
    registrationBenefits {
      text
    }
  }
`;
